export default __webpack_public_path__ + "static/Plots0009-38967059241601191e564119533ed6a4.jpg";